import { WaterHeaterSystemDesign } from 'types';

export const calculateWaterHeaterSystemDesignTotalCost = (systemDesign: WaterHeaterSystemDesign): number => {
  const totalCost = systemDesign?.systems?.reduce((sum, system) => {
    return (
      sum +
      (parseFloat((system.equipment.totalCost as any) || 0) +
        parseFloat((system.sitePrep?.totalCost as any) || 0) -
        parseFloat((system.discounts?.totalCost as any) || 0))
    );
  }, 0);
  return Math.round((totalCost || 0) * 100) / 100;
};
